/**
 * 문의하기 GraphQL 쿼리/뮤테이션
 * 쿼리 문자열은 @ict/shared에서 공유 (DRY)
 */
import { gql } from "@apollo/client";
import {
  CREATE_CONTACT_ISSUE_STRING,
  MY_CONTACT_ISSUES_STRING,
  CANCEL_CONTACT_ISSUE_STRING,
} from "@ict/shared/graphql/queries/contact";

export const CREATE_CONTACT_ISSUE = gql`
  ${CREATE_CONTACT_ISSUE_STRING}
`;

export const MY_CONTACT_ISSUES = gql`
  ${MY_CONTACT_ISSUES_STRING}
`;

export const CANCEL_CONTACT_ISSUE = gql`
  ${CANCEL_CONTACT_ISSUE_STRING}
`;
